<template>
    <IconBase  v-bind="$props" v-on="$listeners">
        <path
        d="M17 12H12V17C12 17.2652 11.8946 17.5196 11.7071 17.7071C11.5196 17.8946 11.2652 18 11 18C10.7348 18 10.4804 17.8946 10.2929 17.7071C10.1054 17.5196 10 17.2652 10 17V12H5C4.73478 12 4.48043 11.8946 4.29289 11.7071C4.10536 11.5196 4 11.2652 4 11C4 10.7348 4.10536 10.4804 4.29289 10.2929C4.48043 10.1054 4.73478 10 5 10H10V5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4C11.2652 4 11.5196 4.10536 11.7071 4.29289C11.8946 4.48043 12 4.73478 12 5V10H17C17.2652 10 17.5196 10.1054 17.7071 10.2929C17.8946 10.4804 18 10.7348 18 11C18 11.2652 17.8946 11.5196 17.7071 11.7071C17.5196 11.8946 17.2652 12 17 12Z"
        fill="#6466ED" />
   </IconBase>
</template>

<script>
import IconBase from './iconBase/IconBase.vue'
import iconProps from './iconBase/iconProps.js'

export default {
  components: { IconBase },
  props: {
    ...iconProps,
    height: {
        ...iconProps.height,
        default: 22,
    },
    width: {
        ...iconProps.width,
        default: 22,
    },
    viewBox: {
        ...iconProps.viewBox,
        default: "0 0 22 22",
    }
  },
}
</script>